module.exports = __webpack_public_path__ + "img/envelope10.a94c2a40.jpg";